/**
 * @author Owais Liaquat Ali
 * @datetime May, 23th 2022
 * @description: This is add User details that is responsible for every childs components actions
 */
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { Building } from 'src/app/building-managment/building-management-interfaces';
import {
  FilterUserParameter,
  IAddNewUser,
  IExistingUser,
  IShareAccess,
  IUnitAndAccessPoint,
  IUser,
} from '../user-management-interfaces';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { IUserEntity, UserEntities } from './add-user-management.interface';
import { UserManagementService } from '../user-management.service';
import {
  convertParseDateTime,
  removeSpecialChar,
  resetForm,
} from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { BuildingListingComponent } from './building-listing/building-listing.component';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { UserDetailsComponent } from './user-details/user-details.component';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { transformPhone } from 'src/app/shared/utils/utility.service';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { PhoneNumberFormatPipe } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.pipe';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { AccessTimeComponent } from './access-time/access-time.component';
import { AddUserService } from './add-user.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from 'src/app/shared/utils/utility.service';
import { finalize } from 'rxjs/operators';
import { profileEmail } from '../user-profile/profile-management.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit, OnDestroy {
  formGroup!: FormGroup;
  newUserForm!: FormGroup;
  newUserFlow = true;
  creatingUser = false;
  createdUserEmail = '';
  createdUserName = '';
  existingUser: IExistingUser | null = null;
  existingUserEmail = '';
  duplicateNameUsers: IExistingUser[] = [];
  private newUserSubscriptions = new Subscription();

  subscription: Subscription | undefined;
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  orignalFormData: string | undefined;
  stepper = 0;
  skipStepUserType = false;
  skipStepBuilding = false;
  selectedUnitAccessPoint = {} as IUnitAndAccessPoint;
  toggleFormUnit = false;
  buildingList: Building;
  errorMessage: string | undefined;
  sharedData?: ISharedData;
  siteId: string | undefined;
  buildingId: string | undefined;
  alreadySelectedGroups!: string[] | undefined;
  accessPointEntityOrignal: string[] = [];

  pageSize = 40;
  userGroup: any | undefined;
  selectedGroup: any | undefined;
  isLoading$: any;
  siteTimeZone: string | undefined;
  commonAccessControl!: boolean;
  filterUserParam: FilterUserParameter[] | undefined;
  searchedWord!: string;

  @ViewChild(BuildingListingComponent)
  buildingListingRefComp!: BuildingListingComponent;

  @ViewChild(UserDetailsComponent) userDetailRefComp:
    | UserDetailsComponent
    | undefined;
  @ViewChild(VerifyEmailComponent) verifyEmailRefComp:
    | VerifyEmailComponent
    | undefined;
  @ViewChild(AccessTimeComponent) accessTimeComponentRefComp:
    | AccessTimeComponent
    | undefined;
  /**
   * @description constructor injects all necesary services
   * @param { AddUserComponent } dialogRef
   */
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddUserComponent>,
    private sharedDataService: SharedDataService,
    private userManagementService: UserManagementService,
    private buildingManagementService: BuildingManagementService,
    private notificationService: NotificationService,
    private helperService: HelperService,
    private phoneNumberFormatPipe: PhoneNumberFormatPipe,
    private loaderService: LoaderService,
    private adduserService: AddUserService,
    private localizationService: LocalizationService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private translate: TranslateService,
    private router: Router
  ) {
    this.selectedUnitAccessPoint.units = [];
    this.selectedUnitAccessPoint.accessPoints = [];
  }

  get userName(): string {
    const userDetails = this.formGroup.get('userDetails');
    if (userDetails) {
      const firstName = userDetails.get('firstName')?.value || '';
      const lastName = userDetails.get('lastName')?.value || '';
      return `${firstName} ${lastName}`;
    }
    return '';
  }
  /**
   *  @description call when initialize time do necessary feature add
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.newUserFlow = !this.modalData?.accessSharing;
    this.createNewUserControls();
    if (this.newUserFlow) {
      this.dialogRef.addPanelClass('add-new-user-modal');
      this.dialogRef.updateSize('400px');
    }
    this.filterUserParam = this.sharedDataService.filterUser;
    this.searchedWord = this.sharedDataService.searchFilterUserWord;

    this.siteTimeZone = this.modalData?.siteTimeZone;
    this.createControls();
    this.newUserSubscriptions.add(
      this.sharedDataService.currentData.subscribe((sharedData) => {
        this.sharedData = sharedData;
        this.commonAccessControl = sharedData.selectedSite.commonAccessControl;
        const currentSiteId = this.sharedData?.selectedSite?.siteId;
        this.buildingId = String(this.sharedData?.selectedBuilding?.buildingId);
        if (currentSiteId && currentSiteId !== this.siteId) {
          this.siteId = String(currentSiteId);
        }
      })
    );
    this.adduserService.resetAll();
    this.isLoading$ = this.loaderService.isLoading;
    if (!this.newUserFlow) this.getBuildingList();
  }

  createNewUserControls(): void {
    const backendNamePattern =
      /^\s*[A-Za-zÀ-ÖØ-öø-ÿ](?:[A-Za-zÀ-ÖØ-öø-ÿ0-9]|[',.%&()\/# -]+(?=[A-Za-zÀ-ÖØ-öø-ÿ0-9]))*\s*$/;
    const requiredName = [
      Validators.required,
      MFValidators.whitespace,
      Validators.maxLength(32),
      Validators.pattern(backendNamePattern),
    ];
    this.newUserForm = this.fb.group({
      firstName: ['', requiredName],
      middleName: [
        '',
        [Validators.maxLength(32), Validators.pattern(backendNamePattern)],
      ],
      lastName: ['', requiredName],
      email: [
        '',
        (control: any) => (control.value ? MFValidators.email(control) : null),
      ],
      region: ['+1'],
      phone: ['', MFValidators.usCaPhone],
      notes: ['', Validators.maxLength(100)],
    });
  }

  get newUserName(): string {
    return ['firstName', 'middleName', 'lastName']
      .map((field) => this.newUserForm.get(field)?.value?.trim())
      .filter(Boolean)
      .join(' ');
  }

  createNewUser(isDuplicateNameVerified = false): void {
    if (this.creatingUser || this.newUserForm.invalid || !this.siteId) {
      this.newUserForm.markAllAsTouched();
      return;
    }
    const values = this.newUserForm.value;
    const variables: IAddNewUser = {
      siteId: this.siteId,
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
    };
    for (const field of ['middleName', 'email', 'notes'] as const) {
      const value = values[field]?.trim();
      if (value) variables[field] = value;
    }
    if (values.phone?.trim()) {
      variables.phoneNumber = values.phone.trim().startsWith('+')
        ? transformPhone(values.phone.trim())
        : transformPhone(`${values.region}${values.phone}`);
    }
    if (isDuplicateNameVerified) variables.isDuplicateNameVerified = true;
    this.creatingUser = true;
    this.newUserSubscriptions.add(
      this.userManagementService
        .addNewUser(variables)
        .pipe(finalize(() => (this.creatingUser = false)))
        .subscribe({
          next: (response) => {
            if (response.duplicateEmailUsers) {
              const identity =
                response.duplicateEmailUsers.email || response.email;
              if (!identity) {
                this.notificationService.showError(
                  this.translate.instant('ADD_USER_FAILED')
                );
                return;
              }
              this.existingUser = response.duplicateEmailUsers;
              this.existingUserEmail = identity;
              return;
            }
            if (
              response.duplicateNameUsers?.length &&
              !isDuplicateNameVerified
            ) {
              this.duplicateNameUsers = response.duplicateNameUsers;
              return;
            }
            if (!response.email) {
              this.notificationService.showError(
                this.translate.instant('ADD_USER_FAILED')
              );
              return;
            }
            this.createdUserEmail = response.email;
            this.createdUserName = this.newUserName;
            this.dialogRef.updateSize('400px');
            this.getUserList();
          },
          error: (error: Error) =>
            this.notificationService.showError(error.message),
        })
    );
  }

  viewNewUserProfile(): void {
    if (!this.createdUserEmail) return;
    this.dialogRef.close();
    this.router.navigate([
      '/users',
      Utility.encodeToBase64(this.createdUserEmail),
    ]);
  }

  get showUserAlreadyOnSite(): boolean {
    return this.existingUser?.isAssociatedWithSite === true;
  }

  get existingUserMaskedName(): string {
    const name = [
      this.existingUser?.firstName,
      this.existingUser?.middleName,
      this.existingUser?.lastName,
    ]
      .filter(Boolean)
      .join(' ')
      .trim();
    if (!name) return '—';
    if (this.showUserAlreadyOnSite) return name;
    const firstName = name.split(/\s+/)[0];
    return firstName + '*'.repeat(Math.max(name.length - firstName.length, 1));
  }

  get existingUserMaskedPhone(): string {
    if (this.showUserAlreadyOnSite) {
      return this.existingUser?.phoneNumber || '—';
    }
    const digits = this.existingUser?.phoneNumber?.replace(/\D/g, '');
    return digits ? `***-***-**${digits.slice(-2)}` : '—';
  }

  get existingUserDisplayEmail(): string {
    return profileEmail(this.existingUser || undefined);
  }

  get existingUserType(): string {
    const type = this.existingUser?.userType;
    return type != null ? userTypeResponse[type] || String(type) : '—';
  }

  duplicateUserName(user: IExistingUser): string {
    return (
      [user.firstName, user.middleName, user.lastName]
        .filter(Boolean)
        .join(' ') || '—'
    );
  }

  duplicateUserInitials(user: IExistingUser): string {
    return (
      [user.firstName, user.lastName]
        .filter(Boolean)
        .map((part) => part![0])
        .join('')
        .slice(0, 2)
        .toUpperCase() || '—'
    );
  }

  duplicateUserType(user: IExistingUser): string {
    const roleLabels: { [type: number]: string } = {
      1: 'PMA',
      2: 'PMU',
      3: 'IA',
      4: 'IU',
      5: 'RA',
      6: 'R',
      7: 'R',
      8: 'EOL Tester',
      9: 'Unassigned',
    };
    return user.userType != null
      ? roleLabels[user.userType] || String(user.userType)
      : '—';
  }

  openDuplicateUserProfile(user: IExistingUser): void {
    if (!user.email) return;
    this.dialogRef.close();
    this.router.navigate(['/users', Utility.encodeToBase64(user.email)]);
  }

  continueWithNewUser(): void {
    this.duplicateNameUsers = [];
    this.createNewUser(true);
  }

  viewExistingUserProfile(): void {
    if (!this.existingUserEmail) return;
    this.dialogRef.close();
    this.router.navigate([
      '/users',
      Utility.encodeToBase64(this.existingUserEmail),
    ]);
  }

  useDifferentEmail(): void {
    this.existingUser = null;
    this.existingUserEmail = '';
  }

  addAnotherUser(): void {
    this.createdUserEmail = '';
    this.createdUserName = '';
    this.newUserForm.reset({ region: '+1' });
  }

  closeNewUserDialog(): void {
    if (!this.creatingUser) this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.newUserSubscriptions.unsubscribe();
  }

  /**
   * @description get all building from store
   * @returns void
   */
  getBuildingList(): void {
    this.buildingManagementService
      .getAllBuildingsBySiteId(this.sharedData?.selectedSite?.siteId)
      .subscribe({
        next: (buildings: Building) => {
          this.adduserService.setBuildingList(buildings);
        },
        error: (err: any) => {
          if (window.__dev__) console.log('getBuildingList', err);
        },
      });
  }

  /**
   * @description Create all child component into parents
   * @returns void
   */
  createControls(): void {
    this.formGroup = this.fb.group({
      userDetails: this.fb.group({
        firstName: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.whitespace,
            MFValidators.maxLength(32),
            MFValidators.nameWithAllowedSpecialChars,
          ]),
        ],
        lastName: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.whitespace,
            MFValidators.maxLength(32),
            MFValidators.nameWithAllowedSpecialChars,
          ]),
        ],
      }),
      userTypes: this.fb.group({
        userType: ['', MFValidators.compose([MFValidators.required])],
      }),
      buildingList: this.fb.group({
        entities: ['', MFValidators.compose([MFValidators.required])],
      }),
      accessTime: this.fb.group(
        {
          startTime: [''],
          expireTime: [''],
          repeat: [false],
        },
        {
          validator: [
            MFValidators.startTimeEndTime('startTime', 'expireTime'),
            MFValidators.startTimeSiteZoneValidator(
              'startTime',
              this.siteTimeZone!
            ),
            MFValidators.siteZoneValidator('expireTime', this.siteTimeZone!),
          ],
        }
      ),
      accessEmail: this.fb.group({
        email: [
          '',
          MFValidators.compose([MFValidators.required, MFValidators.email]),
        ],
        region: [
          '',
          MFValidators.compose([MFValidators.required, MFValidators.region]),
        ],
        phone: [
          '',
          MFValidators.compose([MFValidators.required, MFValidators.usCaPhone]),
        ],
      }),
      Email: this.fb.group({
        existingUserId: [''],
        email: [
          '',
          MFValidators.compose([MFValidators.required, MFValidators.email]),
        ],
      }),
    });
    // // default value set reference ticket# MPC-5978
    this.formGroup?.controls?.accessEmail?.patchValue({
      region: CONSTANTS.PHONE_NUMBER_REGION,
    });
    this.formGroup.get('accessEmail.region')?.disable();

    // in case form state create mode
    if (!this.modalData.isEditable)
      this.orignalFormData = JSON.stringify(this.formGroup.value);
  }

  /**
   * @description form submit get all fromgroup reference here to transform data
   * as per server object requirement
   * @returns void
   */
  submitToParent(): void {
    this.formGroup.controls.userDetails.enable();
    this.formGroup.controls.accessEmail.enable();
    this.formGroup.controls.userTypes.enable();
    let userDetail: IShareAccess | any = {};
    if (this.userGroup) {
      userDetail.userGroups = this.userGroup
        ?.filter((userGroup: any) => {
          return !userGroup?.alreadySelected;
        })
        ?.map((userGroup: any) => userGroup?.userGroupId);
    }

    if (!this.formGroup.value?.Email?.existingUserId) {
      userDetail.email = this.formGroup.value?.accessEmail?.email;
      userDetail.phone = `${this.formGroup.value?.accessEmail?.region}${this.formGroup.value?.accessEmail?.phone}`;
      userDetail.phone = transformPhone(userDetail.phone);
      userDetail.firstName = this.formGroup.value?.userDetails?.firstName;
      userDetail.lastName = this.formGroup.value?.userDetails?.lastName;
      userDetail.userType = this.formGroup.value?.userTypes?.userType;
    } else {
      userDetail.existingUserId = this.formGroup.value?.Email?.existingUserId;
      userDetail.phone = `${this.formGroup.value?.accessEmail?.region}${this.formGroup.value?.accessEmail?.phone}`;
      userDetail.phone = transformPhone(userDetail.phone);
      userDetail.firstName = this.formGroup.value?.userDetails?.firstName;
      userDetail.lastName = this.formGroup.value?.userDetails?.lastName;
      userDetail.userType = this.formGroup.value?.userTypes?.userType;
    }

    if (this.formGroup.value?.accessTime?.repeat) {
      const userStartTimeEndTime = this.startTimeEndTimeUpdate();
      userDetail.repeatStartTime = userStartTimeEndTime.repeatStartTime;
      userDetail.repeatEndTime = userStartTimeEndTime.repeatEndTime;

      userDetail.repeatDays = this.formGroup.value?.accessTime?.repeatDays;
    } else {
      this.formGroup.value?.accessTime?.startTime
        ? (userDetail.startTime = convertParseDateTime(
            this.formGroup.value?.accessTime?.startTime,
            "EEE, MMM do, yyyy 'at' h:mm a",
            "yyyy-MM-dd'T'HH:mm:ss"
          ))
        : (userDetail.startTime = CONSTANTS.NOW);

      this.formGroup.value?.accessTime?.expireTime
        ? (userDetail.expireTime = convertParseDateTime(
            this.formGroup.value?.accessTime?.expireTime,
            "EEE, MMM do, yyyy 'at' h:mm a",
            "yyyy-MM-dd'T'HH:mm:ss"
          ))
        : null;
    }

    const userEntities: UserEntities | undefined =
      this.adduserService.getSelectedFloorUnits();
    userDetail.siteId = this.sharedData?.selectedSite?.siteId as string;

    if (
      userDetail.userType &&
      userTypeResponse[userDetail.userType] !==
        CONSTANTS.PROPERTY_MANAGER_ADMIN &&
      userTypeResponse[userDetail.userType] !== CONSTANTS.PROPERTY_MANAGER_USER
    ) {
      userDetail.entities = userEntities
        ?.filter((entity: any) => {
          return !entity.alreadySelected;
        })
        ?.map((entity: IUserEntity) => {
          return {
            unitId: entity?.unitId ?? null,
            accessPointId: entity?.accessPointId ?? null,
            floorId: entity?.floorId,
            buildingId: entity?.buildingId,
          };
        });
    } else {
      userDetail.entities = [];
    }

    this.userManagementService.shareAccess(userDetail).subscribe({
      next: () => {
        this.getBuildingList();
        this.getUserList();
        this.stepper += 1;
        this.adduserService.resetAll();
      },
      error: (err: Error) => {
        if (window.__dev__) console.log('submitToParent', err);
        this.notificationService.showError(err.message);
        this.formGroup.get('accessEmail.region')?.disable();
        if (this.formGroup.value?.Email?.existingUserId) {
          this.formGroup.controls.userDetails.disable();
          this.formGroup.controls.accessEmail.disable();
          this.formGroup.controls.userTypes.disable();
        }
      },
    });
  }
  /**
   * @description this function is responsible of validated start time & end time and set default value if not given
   * @returns Interface of Ishareaccess
   */
  startTimeEndTimeUpdate(): IShareAccess {
    const userDetail: IShareAccess = {};

    if (
      !(
        this.formGroup.value?.accessTime?.repeatStartTime &&
        this.formGroup.value?.accessTime?.repeatEndTime
      )
    ) {
      // default value MPC-6375
      userDetail.repeatStartTime = convertParseDateTime(
        '12:00 AM',
        'hh:mm a',
        'HH:mm'
      );
      userDetail.repeatEndTime = convertParseDateTime(
        '11:59 PM',
        'hh:mm a',
        'HH:mm'
      );
    } else {
      userDetail.repeatStartTime = convertParseDateTime(
        this.formGroup.value?.accessTime?.repeatStartTime,
        'hh:mm a',
        'HH:mm'
      );

      userDetail.repeatEndTime = convertParseDateTime(
        this.formGroup.value?.accessTime?.repeatEndTime,
        'hh:mm a',
        'HH:mm'
      );
    }
    return userDetail;
  }

  /**
   * @description call user list API here to update list through store
   * @returns void
   */
  getUserList(): void {
    this.filterUserParam
      ? this.userManagementService
          .getUsersBySite(
            this.siteId!,
            this.searchedWord,
            CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
            false,
            this.pageSize,
            false,
            this.filterUserParam,
            undefined,
            true
          )
          .subscribe({
            error: (error: Error) =>
              this.notificationService.showError(error.message),
          })
      : this.userManagementService
          .getAllUsers(
            this.siteId!,
            CONSTANTS.GET_USERS_BY_SITES_OPERATION_UPDATE,
            this.pageSize,
            undefined,
            false,
            true,
            false,
            this.searchedWord
          )
          .subscribe({
            error: (error: Error) =>
              this.notificationService.showError(error.message),
          });
  }

  /**
   * @description this function responsible of existing user list when select any user execute this function
   * @return void
   * @param user user object
   */

  currentUserEmitter(user: IUser): void {
    if (user) {
      this.adduserService.setAlreadySelectedEntities(user);
      this.adduserService.setBuildingingEntitiesCount();

      if (user?.groupIds) {
        this.alreadySelectedGroups = [...user.groupIds!];
      }

      let name = user.name?.split(' ') || '';
      if (this.formGroup.value?.Email?.existingUserId) {
        this.formGroup.controls?.userDetails.patchValue({
          firstName: name[0],
          lastName: name[1],
        });
        this.formGroup.controls?.Email.patchValue({
          email: user.email,
        });

        this.formGroup.controls?.userTypes.patchValue({
          userType:
            typeof user.userType === 'number'
              ? user.userType
              : UserTypeRequest[
                  this.translate.instant(user.userType as string)
                ],
        });
        this.setPhoneRegionEmail(user.phoneNumber!, user.email!);
        this.formGroup.controls.userDetails.disable();
        this.formGroup.controls.accessEmail.disable();

        this.formGroup.controls.userTypes.disable();
      } else {
        resetForm(this.formGroup.controls.accessEmail as FormGroup, '');
        this.formGroup.controls?.accessEmail.patchValue({
          region: CONSTANTS.PHONE_NUMBER_REGION,
        });
        this.formGroup.controls?.accessEmail.enable();
      }
    } else {
      this.selectedUnitAccessPoint = { accessPoints: [], units: [] };
      this.alreadySelectedGroups = [];
      this.selectedGroup = [];
    }
  }

  setPhoneRegionEmail(phone: string, email: string): void {
    this.helperService.validatePhoneFormat(phone).subscribe(
      ({
        phoneNumber,
        region,
        code,
      }: {
        phoneNumber: string;
        region: string;
        code: string;
      }) => {
        this.formGroup.controls?.accessEmail.patchValue({
          phone: removeSpecialChar(phoneNumber),
          region: code,
          email,
        });
      },
      (err: string) => {
        if (window.__dev__) console.log('setPhoneNumber', err);
      }
    );
  }

  /**
   * @description reset all child form and  states
   * @returns void
   */
  formReset(): void {
    this.formGroup.reset();
    resetForm(this.formGroup.get('accessEmail') as FormGroup, '');

    this.formGroup.get('accessEmail.region')?.disable();
    this.verifyEmailRefComp?.removeUser();
    this.verifyEmailRefComp?.isFlag.next(true);
    this.userGroup = undefined;
    this.selectedGroup = undefined;
    this.skipStepUserType = false;
    this.skipStepBuilding = false;
    (this.formGroup.get('accessTime') as FormGroup).patchValue({
      repeat: false,
    });
    (this.formGroup.get('accessTime') as FormGroup).removeControl(
      'repeatStartTime'
    );
    (this.formGroup.get('accessTime') as FormGroup).removeControl(
      'repeatEndTime'
    );
    (this.formGroup.get('accessTime') as FormGroup).removeControl('repeatDays');
    this.selectedUnitAccessPoint = { accessPoints: [], units: [] };
    this.alreadySelectedGroups = [];
    this.stepper = 0;
  }

  /**
   * @description close modal popup
   * @returns void
   */
  closeDialog() {
    if (this.orignalFormData === JSON.stringify(this.formGroup.value)) {
      this.dialogRef?.close();
      return;
    }

    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }
}
